const tabsInit = () => {
	// console.log( tabsInit );
	const isProfesional = document.querySelector( '.product-details-pro' );
	if ( ! isProfesional ) return;
	const accordionContainer = isProfesional.querySelector(
		'.product-details-accordion'
	);
	let tabsContainer = null;
	let isTabsActive = false;

	const createTabsStructure = () => {
		if ( ! accordionContainer || isTabsActive ) return;

		const accordion = accordionContainer.querySelector( '.accordion' );
		const panels = accordion.querySelectorAll( '.accordion-panel' );

		// Create tab structure
		tabsContainer = document.createElement( 'div' );
		tabsContainer.classList.add( 'product-tabs-wrapper' );

		const tabList = document.createElement( 'ul' );
		tabList.classList.add( 'product-tabs-nav' );
		tabList.setAttribute( 'role', 'tablist' );

		const tabContent = document.createElement( 'div' );
		tabContent.classList.add( 'product-tabs-content' );

		// Convert panels to tabs
		panels.forEach( ( panel, index ) => {
			const button = panel.querySelector( '.accordion-trigger' );
			const content = panel.querySelector( '.accordion-content' );

			// Create tab item
			const tabItem = document.createElement( 'li' );
			tabItem.classList.add( 'product-tab-item' );
			tabItem.setAttribute( 'role', 'presentation' );

			const tabLink = document.createElement( 'a' );
			tabLink.href = `#panel-${ index }`;
			tabLink.classList.add( 'product-tab-link' );
			tabLink.setAttribute( 'role', 'tab' );
			tabLink.setAttribute( 'aria-controls', `panel-${ index }` );
			tabLink.setAttribute( 'tabindex', index === 0 ? '0' : '-1' );
			tabLink.textContent = button.textContent;

			tabItem.appendChild( tabLink );
			tabList.appendChild( tabItem );

			// Clone and prepare content panel
			const tabPanel = content.cloneNode( true );
			tabPanel.id = `panel-${ index }`;
			tabPanel.classList.remove( 'accordion-content' );
			tabPanel.classList.add( 'product-tab-panel' );
			tabPanel.setAttribute( 'role', 'tabpanel' );
			tabPanel.setAttribute( 'aria-labelledby', `tab-title-${ index }` );
			tabContent.appendChild( tabPanel );
		} );

		tabsContainer.appendChild( tabList );
		tabsContainer.appendChild( tabContent );

		// Replace accordion with tabs
		accordionContainer.style.display = 'none';
		accordionContainer.parentNode.insertBefore(
			tabsContainer,
			accordionContainer
		);

		// Add tab functionality
		addTabListeners();
		isTabsActive = true;
	};

	const restoreAccordionStructure = () => {
		if ( ! isTabsActive || ! tabsContainer ) return;

		tabsContainer.remove();
		accordionContainer.style.display = 'block';
		tabsContainer = null;
		isTabsActive = false;
	};

	const addTabListeners = () => {
		if ( ! tabsContainer ) return;

		const tabLinks = tabsContainer.querySelectorAll( '.product-tab-link' );
		const tabPanels =
			tabsContainer.querySelectorAll( '.product-tab-panel' );

		const activateTab = ( index ) => {
			// Remove active states
			tabLinks.forEach( ( tabLink ) => {
				tabLink.classList.remove( 'active' );
				tabLink.setAttribute( 'aria-selected', 'false' );
				tabLink.setAttribute( 'tabindex', '-1' );
			} );
			tabPanels.forEach( ( panel ) => {
				panel.classList.remove( 'active' );
				panel.setAttribute( 'aria-hidden', 'true' );
			} );

			// Add active state
			tabLinks[ index ].classList.add( 'active' );
			tabLinks[ index ].setAttribute( 'aria-selected', 'true' );
			tabLinks[ index ].setAttribute( 'tabindex', '0' );
			tabPanels[ index ].classList.add( 'active' );
			tabPanels[ index ].setAttribute( 'aria-hidden', 'false' );
		};

		tabLinks.forEach( ( link, index ) => {
			link.addEventListener( 'click', ( e ) => {
				e.preventDefault();
				activateTab( index );
			} );

			// Keyboard navigation
			link.addEventListener( 'keydown', ( e ) => {
				let newIndex = index;

				switch ( e.key ) {
					case 'ArrowRight':
						newIndex = ( index + 1 ) % tabLinks.length;
						break;
					case 'ArrowLeft':
						newIndex =
							( index - 1 + tabLinks.length ) % tabLinks.length;
						break;
					case 'Home':
						newIndex = 0;
						break;
					case 'End':
						newIndex = tabLinks.length - 1;
						break;
					case 'Enter':
					case ' ':
						e.preventDefault();
						activateTab( index );
						return;
					default:
						return;
				}

				e.preventDefault();
				tabLinks[ newIndex ].focus();
				activateTab( newIndex );
			} );

			// Activate first tab
			if ( index === 0 ) {
				activateTab( 0 );
			}
		} );
	};

	const handleResize = () => {
		const screenWidth = window.innerWidth;

		if ( screenWidth >= 1024 && ! isTabsActive ) {
			createTabsStructure();
		} else if ( screenWidth < 1024 && isTabsActive ) {
			restoreAccordionStructure();
		}
	};

	// Initialize on load
	handleResize();

	// Listen for resize events with debounce
	let resizeTimeout;
	window.addEventListener( 'resize', () => {
		clearTimeout( resizeTimeout );
		resizeTimeout = setTimeout( handleResize, 150 );
	} );
};

export default tabsInit;
